import {
  parseTinkMessageEvent,
  TinkMessageEvent,
  TinkMessageEventRaw,
} from './parseTinkMessageEvent';
import React, { useCallback, useEffect, useMemo } from 'react';
import styles from './TinkIFrame.module.scss';

export interface TinkProps {
  onTinkEvent?: (event: TinkMessageEvent) => void;
}

export const TinkIFrame: React.FC<TinkProps> = ({ onTinkEvent }) => {
  const tinkUrl = useMemo(() => {
    const clientId = process.env.REACT_APP_TINK_CLIENT_ID;
    const currentOrigin =
      typeof window !== 'undefined' && typeof window.location !== 'undefined'
        ? window.location.origin
        : '';

    if (clientId == null) {
      throw new Error('clientId is null');
    }

    const result = new URL('https://link.tink.com/1.0/reports/create-report');

    result.searchParams.append('client_id', clientId.toString());
    /** Required to match Tink console configuration in order to get successful response */
    result.searchParams.append('redirect_uri', `${currentOrigin}/callback`);
    result.searchParams.append('market', 'SE');
    result.searchParams.append('locale', 'sv_SE');
    /** Types of reports that need to be requested from Tink */
    result.searchParams.append(
      'report_types',
      'ACCOUNT_VERIFICATION_REPORT,TRANSACTION_REPORT',
    );
    process.env.REACT_APP_TINK_CLIENT_USE_TEST_BANK === 'true' &&
      result.searchParams.append('test', 'true');
    result.searchParams.append('iframe', 'true');

    return result;
  }, []);

  const receiveTinkStatusData = useCallback(
    (event: TinkMessageEventRaw) => {
      if (event.origin !== 'https://link.tink.com') {
        return;
      }
      onTinkEvent?.(parseTinkMessageEvent(event));
    },
    [onTinkEvent],
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('message', receiveTinkStatusData, false);
      return () => {
        window.removeEventListener('message', receiveTinkStatusData, false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <iframe
      className={styles.iframe}
      title="Tink"
      src={tinkUrl.toString()}
      width="100%"
    />
  );
};
